import { isCloudMode } from './storageMode'

const base = ((import.meta as any).env?.VITE_API_URL ?? '').replace(/\/$/, '')

export const apiUrl = (endpoint: string) =>
  base ? `${base}${endpoint}` : endpoint

function getToken(): string {
  try {
    return JSON.parse(localStorage.getItem('pulse-auth') ?? '{}')?.state?.token ?? ''
  } catch { return '' }
}

function getCollabRoom(): string | null {
  try { return localStorage.getItem('pulse-collab-room') || null }
  catch { return null }
}

function getActiveTeam(): string | null {
  try { return localStorage.getItem('pulse-active-team') || null }
  catch { return null }
}

export function setCollabRoom(roomId: string | null) {
  if (roomId) localStorage.setItem('pulse-collab-room', roomId)
  else localStorage.removeItem('pulse-collab-room')
}

export function setActiveTeam(teamId: string | null) {
  if (teamId) localStorage.setItem('pulse-active-team', teamId)
  else localStorage.removeItem('pulse-active-team')
}

/** Fetch with auto-attached JWT token */
export function authFetch(url: string, init: RequestInit = {}): Promise<Response> {
  const token = getToken()
  const collabRoom = getCollabRoom()
  const activeTeam = getActiveTeam()
  
  // Build headers as plain object to avoid any Headers API issues
  const existingHeaders: Record<string, string> = {}
  if (init.headers) {
    if (init.headers instanceof Headers) {
      init.headers.forEach((v, k) => { existingHeaders[k] = v })
    } else if (Array.isArray(init.headers)) {
      for (const [k, v] of init.headers) { existingHeaders[k] = v }
    } else {
      Object.assign(existingHeaders, init.headers)
    }
  }
  
  if (token) existingHeaders['Authorization'] = `Bearer ${token}`
  existingHeaders['X-Storage-Mode'] = isCloudMode() ? 'cloud' : 'local'
  // Only send collab room header for read operations (list/read), NOT for writes
  // This prevents writing to someone else's workspace when you have a stale collab session
  const isWriteOp = url.includes('/write') || url.includes('/delete') || url.includes('/move') || url.includes('/mkdir')
  if (collabRoom && !isWriteOp) existingHeaders['X-Collab-Room'] = collabRoom
  if (activeTeam) existingHeaders['X-Team-Id'] = activeTeam

  return fetch(url, { ...init, headers: existingHeaders })
}
